module.exports = __webpack_public_path__ + "statics/img/UserReviews-3.92217c41.png";